import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_NOTES } from '../../graphql/queries';

interface Article {
  createdAt: string;
  id: string;
  title: string;
  tags: string[];
}

interface Category {
  id: string;
  name: string;
  articles: Article[];
}

export const useTOC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const { data, loading } = useQuery(GET_NOTES);

  useEffect(() => {
    if (data?.notes) {
      const notes: Article[] = data.notes;
      
      // Группируем статьи по тегам (категориям)
      const categoryMap = new Map<string, Article[]>();
      
      notes.forEach((note) => {
        if (note.tags && note.tags.length > 0) {
          note.tags.forEach((tag) => {
            const existing = categoryMap.get(tag) || [];
            categoryMap.set(tag, [...existing, note]);
          });
        } else {
          // Статьи без тегов ид в категорию "Разное"
          const existing = categoryMap.get('Разное') || [];
          categoryMap.set('Разное', [...existing, note]);
        }
      });

      // Преобразуем Map в массив
      const categoriesArray: Category[] = Array.from(categoryMap.entries()).map(([id, articles]) => ({
        id,
        name: id,
        articles: articles.sort((a, b) => 
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        ),
      }));

      // Сортируем категории по алфавиту, но "Разное" в конец
      categoriesArray.sort((a, b) => {
        if (a.name === 'Разное') return 1;
        if (b.name === 'Разное') return -1;
        return a.name.localeCompare(b.name);
      });

      setCategories(categoriesArray);
    }
  }, [data]);

  return { categories, loading };
};